import React from 'react'

import _ from 'lodash'
import styles from './styles'
import BuildFinancialSituation from '../BgcExpansible/BuildFinancialSituation'

const ReferenceCheck = (props) => {
  const classes = styles()
  const financialPendings = props.financial_pendings_data
  const score = props.credit_score_data?.quod_score

  if (_.isEmpty(financialPendings) && _.isEmpty(score)) {
    return (
      <div className={classes.expansibleContent}>
        <span>Nenhuma informação encontrada.</span>
      </div>
    )
  }

  return (
    <div>
      {financialPendings ? (
        <BuildFinancialSituation
          financial_situation={{ financial_pendings_data: financialPendings, credit_score_data: props.credit_score_data }}  axa={true} 
        />
      ) : null}
    </div>
  )
}

export default ReferenceCheck
